export default function ContentTitle({
  title,
  titleEn,
}: { title: string; titleEn: string }) {
  return (
    <div
      className={`
        flex items-center justify-center
        w-full h-[120px] md:h-[318px]
        m-0 md:-mt-20
        p-0 md:pt-20
        bg-[url(/images/common/content_title_bg_sp.webp)]
        md:bg-[url(/images/common/content_title_bg.webp)]
        bg-center bg-no-repeat bg-cover
      `}
    >
      <h1 className="text-[18px] md:text-[32px]">
        <span
          className={`
            block
            mb-1.5 mx-auto
            text-[15px] md:text-[18px]
            text-center font-medium
          `}
        >
          {titleEn}
        </span>
        {title}
      </h1>
    </div>
  )
}
